import { ReactComponent } from './transferDownIcon.svg'

export const TransferDownIcon = ReactComponent
